
export const QUERY_HISTORY_STORAGE_KEY = 'query-history'

export interface QueryHistoryEntry {
  timestamp: number
  query: string
  alias?: string
  starred?: boolean
}

export const addQueryToHistory = (
  challengeId: string,
  query: string
): QueryHistoryEntry[] => {
  const queryHistory = loadQueryHistoryFromStorage()
  if (queryHistory[challengeId]?.some((entry) => entry.query === query)) {
    return queryHistory[challengeId]
  }
  const existingEntries = queryHistory[challengeId] || []
  const updatedEntries = [...existingEntries, { query, timestamp: Date.now() }]

  // Keep only the 30 most recent queries
  queryHistory[challengeId] = updatedEntries.slice(-30)
  saveQueryHistoryToStorage(queryHistory)
  return queryHistory[challengeId]
}

export const getQueryHistoryForChallenge = (challengeId: string): QueryHistoryEntry[] => {
  const queryHistory = loadQueryHistoryFromStorage()
  return queryHistory[challengeId] || []
}

const loadQueryHistoryFromStorage = (): Record<string, QueryHistoryEntry[]> => {
  try {
    const queryHistory = localStorage.getItem(QUERY_HISTORY_STORAGE_KEY)
    return queryHistory ? JSON.parse(queryHistory) as Record<string, QueryHistoryEntry[]> : {}
  } catch {
    return {}
  }
}

const saveQueryHistoryToStorage = (queryHistory: Record<string, QueryHistoryEntry[]>): void => {
  try {
    localStorage.setItem(QUERY_HISTORY_STORAGE_KEY, JSON.stringify(queryHistory))
  } catch (error) {
    console.error('Failed to save query history to localStorage', error)
  }
}

export const toggleStarQuery = (challengeId: string, timestamp: number): void => {
  const queryHistory = loadQueryHistoryFromStorage()
  queryHistory[challengeId] = queryHistory[challengeId]?.map((entry) =>
    entry.timestamp === timestamp ? { ...entry, starred: !entry.starred } : entry
  )
  saveQueryHistoryToStorage(queryHistory)
}

export const clearQueryHistoryFromStorage = (challengeId: string): QueryHistoryEntry[] => {
  const queryHistory = loadQueryHistoryFromStorage()
  queryHistory[challengeId] = queryHistory[challengeId]?.filter((entry) => entry.starred) || []
  saveQueryHistoryToStorage(queryHistory)
  return queryHistory[challengeId]
}

export const updateQueryAlias = (challengeId: string, timestamp: number, alias: string): void => {
  const queryHistory = loadQueryHistoryFromStorage()
  queryHistory[challengeId] = queryHistory[challengeId]?.map((entry) =>
    entry.timestamp === timestamp ? { ...entry, alias } : entry
  )
  saveQueryHistoryToStorage(queryHistory)
}